// extracted by mini-css-extract-plugin
module.exports = {"button":"ScrollToTopButton_button__k3sA1","button__text":"ScrollToTopButton_button__text__jLwvY","button__icon":"ScrollToTopButton_button__icon__W6W67"};